export default __webpack_public_path__ + "static/media/BigLogoBackground.4c6c01a4.svg";